import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AlertTriangle, ArrowUp, Scale } from "lucide-react";
import { useData } from "../data/DataContext";

const Footer = () => {
  const [showTop, setShowTop] = useState(false);
  const { popularSearches, logo } = useData();
  const isHome = useLocation().pathname === "/";

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <footer className="mt-12">
      <div className="max-w-4xl mx-auto px-4">
        {!isHome && (
          <p data-testid="footer-compact-notice" className="text-[13px] text-emerald-50/65 text-center leading-relaxed">
            <AlertTriangle size={13} className="inline -mt-0.5 mr-1 text-[#ffb224]" />
            Independent listing site · 18+ only · real-money apps carry risk · see our{" "}
            <Link to="/disclaimer" className="text-[#ffb224] font-semibold underline">Disclaimer</Link>
          </p>
        )}
        {isHome && (<>
        <div className="bg-[#073c1b] border border-[#1c5f35] rounded-2xl px-4 py-3">
          <p className="text-[13px] leading-relaxed text-emerald-50/70 text-center">
            <span className="font-bold text-[#ffb224]">Popular searches :- </span>
            {popularSearches.join(", ")}
          </p>
        </div>

        <div className="mt-5 bg-[#073c1b] border border-[#1c5f35] border-l-4 border-l-[#ffb224] rounded-2xl px-5 py-4">
          <p className="flex items-center gap-2 font-extrabold text-white mb-2">
            <AlertTriangle size={18} className="text-[#ffb224]" /> Important Notice
          </p>
          <p className="text-[13px] text-emerald-50/75 leading-relaxed">
            <span className="font-bold text-white">Maha Games Apps</span> is a review and listing site. We don't develop, own or run any of the apps on this page, we never hold players' money, and each app works under its own company's terms.
          </p>
          <p className="text-[13px] text-emerald-50/75 leading-relaxed mt-2">
            Playing for real money can become addictive, and you can lose what you put in. Fix a budget before you start, never chase losses, and keep these apps away from anyone <span className="font-bold text-white">under 18</span>. Full details are on our{" "}
            <Link to="/disclaimer" className="text-[#ffb224] font-semibold underline">Disclaimer page</Link>.
          </p>
          <p className="text-[13px] text-emerald-50/75 leading-relaxed mt-2 flex gap-1.5">
            <Scale size={14} className="shrink-0 mt-0.5 text-emerald-50/60" />
            <span>
              <span className="font-bold text-white">Law:</span> India's <span className="font-bold text-white">Promotion and Regulation of Online Gaming Act, 2025</span> prohibits online money games, and several states restricted them even earlier. Please check the law that applies to you before you download or deposit; this notice is not legal advice.
            </span>
          </p>
        </div>

        <p className="text-center text-[#ffb224] font-bold text-sm mt-6">Thanks for reading - play smart and stay safe!</p>
        </>)}
      </div>

      <div className="mt-8 border-t border-[#1c5f35] bg-[#011f0d]">
        <div className="max-w-6xl mx-auto px-4 py-6 flex flex-col items-center gap-4 text-center">
          <div className="flex items-center gap-2">
            <img src={logo} alt="Maha Games Apps" className="w-8 h-8 rounded-lg object-cover" />
            <span className="font-extrabold text-white">Maha <span className="text-[#ffb224]">Games</span> Apps</span>
          </div>
          <div data-testid="footer-links" className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-semibold text-emerald-50/80">
            {[["/yono-all-games", "All Games"], ["/about", "About"], ["/contact", "Contact"], ["/disclaimer", "Disclaimer"], ["/privacy", "Privacy"]].map(([to, l]) => (
              <Link key={to} to={to} className="whitespace-nowrap hover:text-[#ffb224] transition-colors">{l}</Link>
            ))}
          </div>
          <p className="text-xs text-emerald-50/50 font-medium">Copyright © 2026 Maha Games Apps | All Rights Reserved</p>
        </div>
      </div>

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Scroll to top"
        className={`fixed bottom-6 right-6 z-50 w-11 h-11 rounded-xl bg-[#ffb224] text-[#062a13] flex items-center justify-center shadow-xl border-b-[4px] border-[#b47400] transition-all duration-300 ${showTop ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}
      >
        <ArrowUp size={20} strokeWidth={2.6} />
      </button>
    </footer>
  );
};

export default Footer;
